module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('kanban-board', {
    attrs: {
      "title": _vm.value.steps[0].stepName,
      "stages": _vm.stages
    },
    model: {
      value: (_vm.value.steps[0]),
      callback: function($$v) {
        _vm.$set(_vm.value.steps, 0, $$v)
      },
      expression: "value.steps[0]"
    }
  }), _vm._v(" "), _c('kanban-board', {
    attrs: {
      "title": _vm.value.steps[1].stepName,
      "stages": _vm.stages
    },
    model: {
      value: (_vm.value.steps[1]),
      callback: function($$v) {
        _vm.$set(_vm.value.steps, 1, $$v)
      },
      expression: "value.steps[1]"
    }
  }), _vm._v(" "), _c('kanban-board', {
    attrs: {
      "title": _vm.value.steps[2].stepName,
      "stages": _vm.stages
    },
    model: {
      value: (_vm.value.steps[2]),
      callback: function($$v) {
        _vm.$set(_vm.value.steps, 2, $$v)
      },
      expression: "value.steps[2]"
    }
  }), _vm._v(" "), _c('kanban-board', {
    attrs: {
      "title": _vm.value.steps[3].stepName,
      "stages": _vm.stages
    },
    model: {
      value: (_vm.value.steps[3]),
      callback: function($$v) {
        _vm.$set(_vm.value.steps, 3, $$v)
      },
      expression: "value.steps[3]"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fb4056e8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/progress/ProgressSummary.vue
// module id = 1659
// module chunks = 0